import React from 'react'
import { connect } from '@cerebral/react'
import { signal, state } from 'cerebral/tags'
import { css } from 'aphrodite'
import styles from './styles'
import { t } from '@billes/translator-client'

const Action = ({ action, triggerSignal, id }) => {
  if (!action) return null

  const callAction = triggerSignal.bind(null, action.signal)
  const onClick = action.close
    ? () => {
        triggerSignal({
          name: 'app.removeSnackbar',
          args: { snackbar: { id } }
        })
        callAction()
      }
    : () => callAction()

  return (
    <span className={css(styles.action)} onClick={onClick}>
      {t(action.text.key, action.text.params)}
    </span>
  )
}

const Snackbar = ({ action, id, text, triggerSignal, type, visible }) => {
  const style = css(
    styles.snackbar,
    visible ? styles.visible : null,
    styles[type]
  )

  return (
    <div className={style}>
      <span className={css(styles.text)}>{t(text.key, text.params)}</span>
      <Action action={action} id={id} triggerSignal={triggerSignal} />
    </div>
  )
}

export default connect(
  {
    triggerSignal: signal`app.triggerSignal`,
    snackbars: state`app.snackbars`
  },
  function Snackbars({ snackbars, triggerSignal }) {
    return (
      <div className={css(styles.wrapper)}>
        {snackbars.map((snackbar, index) => (
          <Snackbar
            key={snackbar.id}
            {...snackbar}
            triggerSignal={triggerSignal}
          />
        ))}
      </div>
    )
  }
)



// WEBPACK FOOTER //
// ./src/components/Common/Snackbar/snackbar.js